import React from 'react';
import {Button, ButtonGroup} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import {getSessionState} from "../../../utils/date";
import {BUTTON_STATE} from "../../../constant";

const useStyles = makeStyles((theme) => ({
    button: {
        fontSize: '14px',
        padding: '9px 0',
        borderRadius: '0',
        width: '126px',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
    },
    disabled: {
        color: (theme)=>`${theme.palette.button.disable} !important`,
        border: (theme)=>`1px solid ${theme.palette.button.disable} !important`,
    },
    replay: {
        color: (theme)=>`${theme.palette.button.primary} !important`,
        background: (theme)=>`${theme.palette.button.secondary} !important`,

    },
    btnGroup: {
        width: '126px',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
    }
}));

export default function EventButton(props) {
    const {data, isFeatured=false, toggleModal, videoData, onSubmit} = props
    let history = useHistory();
    const theme = useTheme();
    const classes = useStyles(theme);
    const handleClick = (type) => {
        switch (type){
            case BUTTON_STATE.LIVE:
            case BUTTON_STATE.VOD:
                toggleModal(data);
                break;
            case 'buyTicket':
                window.open(data.ticketUrl, "_blank");
                break;
        }

    }

    const showButton = ()=>{
        let btnState = getSessionState(data);
        switch (btnState){
            case BUTTON_STATE.LIVE:
                return  <ButtonGroup className={classes.btnGroup} style={{display: 'block'}}>
                    <Button onClick={()=>handleClick(BUTTON_STATE.LIVE)} className={`${classes.button} secondary-btn`} color={'secondary'} variant={'contained'} style={{display: 'block', marginBottom: '10px'}}> WATCH LIVE</Button>
                    {!isFeatured && data.ticketUrl && <Button onClick={()=>handleClick('buyTicket')} className={`${classes.button} get-ticket`} color={'primary'} variant={'outlined'} style={{display: 'block'}}>GET TICKET</Button>}
                </ButtonGroup>

            case BUTTON_STATE.VOD:
                return <Button onClick={()=>handleClick(BUTTON_STATE.VOD)} className={`${classes.button} watch-replay`} classes={{contained: classes.replay}} variant={'contained'} style={{display: 'block', marginBottom: '10px'}}> WATCH REPLAY</Button>

            case BUTTON_STATE.ENDED:
                return <Button className={classes.button} classes={{disabled: classes.disabled}} variant={"outlined"} disabled>EVENT ENDED</Button>

            case BUTTON_STATE.UNPUBLISHED:
                return data.ticketUrl?<Button onClick={()=>handleClick('buyTicket')} className={classes.button} color={'primary'} variant={'outlined'}>GET TICKET</Button>:<></>
                // return <Button className={classes.button} classes={{disabled: classes.disabled}} variant={"outlined"} disabled>COMING SOON</Button>
                /*return videoData && videoData.defaultVideo=='vod'?<Button onClick={()=>handleClick('replay')} className={classes.button} classes={{contained: classes.replay}} variant={'contained'} style={{display: 'block', marginBottom: '10px'}}> WATCH REPLAY</Button>:
                    <Button className={classes.button} classes={{disabled: classes.disabled}} variant={"outlined"} disabled>EVENT ENDED</Button>*/
        }
    }

    return showButton()
}